import { render, staticRenderFns } from "./BoxActionDelete.vue?vue&type=template&id=3b7a950d&"
import script from "./BoxActionDelete.vue?vue&type=script&lang=ts&"
export * from "./BoxActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports